module.exports = __webpack_public_path__ + "static/media/changes-banner.d1829756.jpg";